import { useState } from 'react';

export const useModalState = <T>() => {
  const [isOpen, setOpen] = useState(false);
  const [data, setData] = useState<T | undefined>();

  const open = (payload?: T) => {
    if (payload) {
      setData(payload);
    }
    setOpen(true);
  };

  const close = () => {
    setData(undefined);
    setOpen(false);
  };

  return {
    isOpen,
    data,
    open,
    close,
  };
};
